import { Image } from 'antd';
import React, { Dispatch, SetStateAction, useState } from 'react';
interface Props {
  imageUrls: string[];
  selectedImage: string;
  visible: boolean;
  onVisibleChange: Dispatch<SetStateAction<boolean>>;
}

function HiddenImagePreview({
  imageUrls,
  selectedImage,
  visible,
  onVisibleChange,
}: Props): React.ReactElement {
  // A controlled current without onChange locks the preview on one image, so
  // keep the image browsed to here and fall back to the clicked one.
  const [current, setCurrent] = useState<number>();

  return (
    <div style={{ display: 'none' }}>
      <Image.PreviewGroup
        preview={{
          visible,
          onVisibleChange: value => {
            if (!value) {
              setCurrent(undefined);
            }
            onVisibleChange(value);
          },
          current: current ?? Math.max(imageUrls.indexOf(selectedImage), 0),
          onChange: setCurrent,
          rootClassName: 'prevent-active-request-drawer-close',
        }}
        key={selectedImage}
      >
        {imageUrls.map(src => (
          <Image src={src} key={src} />
        ))}
      </Image.PreviewGroup>
    </div>
  );
}

export default HiddenImagePreview;
